import { useNavigate } from '@everlutionsk/ui-router';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { Button } from '../coreComponents/button';

export function PageNotFound() {
  const navigate = useNavigate();

  return (
    <Stack justifyItems="center" alignItems="center" sx={{ height: 'calc(100vh - 207px)' }}>
      <Stack spacing={7} sx={{ maxWidth: '640px', margin: 'auto' }}>
        <Typography variant="h3">Page not found</Typography>
        <Typography variant="labelMedium">
          The page you are looking for might be temporarily unavailable or does not exist. Try
          'Refreshing' the page or get in touch if the issue persists.
        </Typography>

        <Stack direction="row" justifyContent="start">
          <Button onClick={() => navigate('/')}>Go to Dashboard</Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
